import { initProcess, ProcessConfig, ConversionResults, ParsedVariables } from './index'
import { FTProcess } from '@/models/FTProcess';
import { ConversionDetails } from '@/models/ConversionDetails';
import _ from 'lodash';

export function loadConfig({ processRow }: ParsedVariables): ProcessConfig {
  return {
    inputs: {
      goods: [
        {
          goodsType: '',
          goodsFilter: {
            type: ['FG']
          },
          multiple: false,
          params: [
            {
              name: 'Width',
              type: 'label',
              value: _.get(processRow, 'goodsObject.dimensions.width', ''),
              unit: 'mm',
              disabled: true
            },
            {
              name: 'Input Quantity',
              type: 'quantity',
              value: 'quantity',
              disabled: false
            }
          ]
        }
      ]
    },
    outputs: {
      type: 'single',
      arguments: [
        {
          name: 'Width',
          type: 'label',
          value: _.get(processRow, 'goodsObject.dimensions.width', ''),
          unit: 'mm',
          disabled: true
        },
        {
          name: 'Output Quantity',
          type: 'label',
          value: _.get(processRow, 'quantity', ''),
          unit: 'KG',
          disabled: true
        }
      ]
    },
    tableHeaders: [
      {
        text: 'Nominal Speed',
        value: 'nominalSpeed'
      },
      {
        text: 'Planned Hours(s)',
        value: 'plannedHours'
      },
      {
        text: 'No of Pieces',
        value: 'numberOfPieces'
      },
      {
        text: 'Expected Output Waste',
        value: 'wastePercentage'
      },
      {
        text: 'Expected Output Waste Weight',
        value: 'waste'
      },
      {
        text: 'Expected Output Net Weight',
        value: 'netWeight'
      }
    ]
  }
}

export function convert(process: FTProcess) : ConversionResults {
  const conversionResult : ConversionResults = {
    inputs: [],
    outputs: [],
    details: new ConversionDetails(),
  };

  initProcess(process);
  const inputFTProcessRow = process.inputs[0];
  const outputFTProcessRow = process.outputs[0];
  outputFTProcessRow.goodsObject.copyFrom(process.inputs[0].goodsObject);
  outputFTProcessRow.quantity = inputFTProcessRow.quantity;

  const netWeight = outputFTProcessRow.quantity;
  conversionResult.outputs[0] = outputFTProcessRow;

  outputFTProcessRow.goodsObject.packingMode = _.get(process,'inputs.0.ftProcess.ftFactoryTicket.order.product.packingMode');
  if(!_.get(outputFTProcessRow, 'goodsObject.perKgRatio.plA.value')) {
    outputFTProcessRow.goodsObject.setPerKgRatio('plA', 1);
  }
  conversionResult.details.numberOfPieces = netWeight * _.get(outputFTProcessRow, 'goodsObject.perKgRatio.plA.value', 1);
  conversionResult.details.totalQuantity = netWeight;
  conversionResult.details.wastePercentage = 0;
  conversionResult.details.waste = 0;
  conversionResult.details.netWeight = netWeight;
  conversionResult.details.kgPerHour = 60 * inputFTProcessRow.goodsObject.unitWeight * process.machineDetail.mechanicalSpeed * (process.machineDetail.pcsPerStroke || 0);
  conversionResult.details.plannedHours = conversionResult.details.kgPerHour ? (conversionResult.details.totalQuantity + conversionResult.details.waste) / conversionResult.details.kgPerHour : 0;

  return conversionResult;
}